import React from "react";
import _get from "lodash/get";
import { Link } from "react-router-dom";
import { Button, Card, Tag, Input, Icon, message, Spin, Select } from "antd";
import { connect } from "react-redux";
import axios from "services/axios";
import "./pdi-style.css";

import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
const { Option } = Select;

class Negotiation extends React.Component {
  state = {
    searchText: "",
    sortOrder: {},
    sort_by: "updatedAt_DESC",
    dataSource: [],
    inspectors: [],
    rangeTime: [],
    isDataReady: false,
    visibleConfirmModal: false,
    count: 1,
    page: 0,
  };

  getMuiTheme = () => createMuiTheme({
    typography: {
      useNextVariants: true,
    },
    overrides: {
      MUIDataTableBodyCell: {
        root: {
          "white-space": "nowrap",
          '&:nth-child(1)': {
            "width": "8em",
            "min-width": "8em",
            "max-width": "8em",
            "word-break": "break-all"
          }
        }
      }
    }
  });
  
  componentDidMount = () => {
    this.fetchInspector()
    this.fetchPDI()
  };

  changePage(page, paginate, query, sortOrder) {
    if(!query) query = "";
    let state = {isDataReady: false, searchText: query, sortOrder};
    let sort_by = this.getSort(sortOrder);
    if(sort_by !== "") state.sort_by = sort_by;
    console.log(sortOrder)
    this.setState(state, () => this.fetchPDI(page, paginate));
  }

  getSort(sortOrder) {
    if(!sortOrder.name) return "updatedAt_DESC";
    let sortDirection = sortOrder.direction.toUpperCase()
    switch(sortOrder.name) {
      case "PIC":
        return `pic_${sortDirection}`
      case "Plat Nomor":
        return `licensePlate_${sortDirection}`
      case "Mobil":
        return `carName_${sortDirection}`
      case "Appraiser":
        return `appraiserName_${sortDirection}`
      default: return ""
    }
  }

  fetchPDI(page=0, paginate=15) {
    const {searchText, sort_by} = this.state;
    axios
      .get(`/pdi?q=${searchText}&page=${page}&limit=${paginate}&sort_by=${sort_by}`)
      .then(result => {
        this.setState({
          dataSource: result.data.inspections,
          isDataReady: true,
          count: result.data.totalItems,
          page: page,
        });
      })
      .catch(err => {
        message.error("Gagal request data PDI");
      });
  }

  fetchInspector() {
    axios
      .get(`/user/inspector-list`)
      .then(({ data: {inspectors} }) => {
        this.setState({
          inspectors
        });
      })
      .catch(err => {
        message.error("Gagal request data PDI");
      });
  }

  visibleModalConfirmation() {
    this.setState({
      visibleConfirmModal: !this.state.visibleConfirmModal
    })
  }

  onChangeRange(date, dateString) {
    this.setState({
      rangeTime: dateString
    })
  }

  inspectorSelection (pdi) {
    return(
      <React.Fragment>
        <Select
          showSearch
          placeholder="Select a person"
          optionFilterProp="children"
          onChange={(value)=> this.selectInspector(value, pdi.id)}
          value={pdi.inspectorId}
        >
          {this.state.inspectors.map((user, index) => {
            return (
              <Option key={index} value={user.id} style={user.status ? { color: "red" } : {}}>
                {user.Inspector.name}
              </Option>
            );
          })}
        </Select>
      </React.Fragment>
    )
  }
  
  async selectInspector (inspectorId, pdiID) {
    try {
      this.setState({isDataReady: true})
      const pdi = await axios.put(`/pdi/${pdiID}/assign-pdi`, {inspectorId})
      await this.fetchPDI()
      message.success("Berhasil assign Inspektor PDI");
    } catch (e) {
      console.log(e)
      message.error("Gagal assign Inspektor PDI");
    }
  }
  displayStatusTag(status) {
    switch (status) {
      case "PDI_WAITING_ASSIGNMENT":;
      case "PDI_CHECKING":
        return <Tag color="orange">{status}</Tag>;
      case "PDI_FINISHED":
        return <Tag color="green">{status}</Tag>
      default:
        return <Tag color="orange">{status}</Tag>;
    }
  }

  getCarType = (brandId, modelId, typeId) => {
    const {Car} = this.props
    let brand = Car.carBrand.find(brand => brand.id == brandId)
    let model = Car.carModel.find(model => model.id == modelId)
    let type = Car.carType.find(ctype => ctype.id == typeId)
    return `${brand ? brand.brand : ""} ${model ? model.carType : ""} ${type ? type.type + " " + type.transmission : ""} `
  }

  render() {
    const {dataSource} = this.state
    const columns = [
      "Action",
      "Status",
      {
        name: "Inspector",
        options: {
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return this.inspectorSelection(value)
          }
        }
      },
      "PIC",
      "Plat Nomor",
      "Mobil",
      "Appraiser",
    ];

    const options = {
      filter: false,
      responsive: 'simple',
      fixedHeader: true,
      tableBodyHeight: '400px',
      print: false,
      selectableRows: 'none',
      rowsPerPage:15,
      serverSide: true,
      count: this.state.count,
      page: this.state.page,
      onTableChange: (action, tableState) => {
        switch (action) {
          case 'changePage':
            this.changePage(tableState.page, tableState.rowsPerPage, this.state.searchText, this.state.sortOrder);
            break;
          case 'changeRowsPerPage':
            this.changePage(tableState.page, tableState.rowsPerPage, this.state.searchText, this.state.sortOrder);
            break;
          case 'search':
            this.changePage(tableState.page, tableState.rowsPerPage, tableState.searchText, this.state.sortOrder);
            break;
          case 'sort':
            this.changePage(tableState.page, tableState.rowsPerPage, this.state.searchText, tableState.sortOrder)
          break;
          default: console.log(action)
        }
      }
    };

    const data = dataSource.map(item => {
      return [
        <Link to={`/home/internal-bidding/pdi/${item.id}/`}>
          <Button size="small" type="primary">
            Compare PDI
          </Button>
        </Link>,
        this.displayStatusTag(item.status),
        {id: item.id, inspectorId: item.inspectorId},
        item.Booking.SalesProfile.BOH || "",
        item.licensePlate,
        item.carName,
        item.Booking.Appraiser.name,
      ]
    });

    return (
      <Card style={{ marginTop: "30px" }}>

        <Spin size="large" spinning={!this.state.isDataReady} tip="Loading...">
          <MuiThemeProvider theme={this.getMuiTheme()}>
            <MUIDataTable
              title={"PDI"}
              data={data}
              columns={columns}
              options={options}
            />
          </MuiThemeProvider>
        </Spin>
      </Card>
    );
  }
}

const mapStateToProps = ({ Auth, Car }) => ({ Auth, Car });

export default connect(mapStateToProps)(Negotiation);



// WEBPACK FOOTER //
// src/components/Dashboard/InternalBidding/PDI/PDI.js